import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero-container">
        <div className="image-container">
        <div className="image-wrapper">
          <img src="/portfolio pic 2.png" alt="Maryann Ichaura" className="hero-image circle-image" />
        </div>
      </div>
      <div className="text-container">
        <h1 className="heading">Hi, I'm Maryann Ichaura</h1>
        <h2 className="subheading">Business Support Virtual Assistant</h2>
        <p className="description">
          Providing professional administrative, executive, and business support
          to help you stay organized and efficient. Let's take your business to the next level!
        </p>
        <button className="cta-button">Hire Me</button>
      </div>
    </section>
  );
};

export default Hero;